import {
  defineComponent, h,
} from 'vue';
import {
  ElImage
} from 'element-plus';
import SvgIcon from '@/components/SvgIcon';
import { getEventIcon } from '@/utils/js/marker-icon';
import filmIconUrl from '@/assets/icon/marker/film.png';
import { antPath } from '@/utils/js/leaflet-plug/leaflet-ant-path-master/src/plugin/main.js'
import { vueCreateAppInit } from '@/utils/js/initVariable';
import * as turf from '@turf/turf'

import warningUrl from '@/assets/icon/marker/warning.png';

import { showPreAnnotationDragPopup, clearPreAnnotationPopup } from './usePolyInfoPanel';

import { getEventAllDetail } from '@/api/UserDrawApi';
import { getAuthLink } from '@/api/UserWorkspaceDataApi';

const loadingHtmlApp = ()=>{
  return vueCreateAppInit(
    defineComponent({
      setup(){
        return ()=> h(SvgIcon, {
          iconName: 'loading',
        })
      },
    })
  )
}
const iconSize = 24,
      iconSizes = [ iconSize, iconSize ],
      iconAnchor = iconSizes.map(e=> e / 2 );
const loadingDom = document.createElement('div');
loadingDom.style.height = iconSize + 'px';
loadingDom.style.width = iconSize + 'px';
loadingHtmlApp().mount(loadingDom);
const loadIcon = L.divIcon({
  html: loadingDom,
  iconSize: iconSizes,
  iconAnchor: iconAnchor,
})

const filmAppInit = (url)=>{
  return vueCreateAppInit(
    defineComponent({
      setup(){
        return ()=> h('video', {
          controls: false,
          style: { width: '200px', height: '120px' },
          src: url,
          autoplay: true,
          loop: true,
          onClick: click=>{
            const video = click.target;
            video.requestFullscreen?.();
          }
        })
      }
    })
  );
}

const itemChange = (item)=>{
  // console.log(item);
  return Object.assign({
    geom: item['geom'] || item['regionGeom'],
    annotationName: item['annotationName'] || item['regionName'],
    eventList: item['eventList'],
    exposureCountList: item['exposureCountList'] || item['exposureDateAggList'],
    regionFeatureList: item['regionFeatureList'] || item['tags'],
    regionIntention: item['regionIntention'] || item['regionDesc'],
    shootingLocationList: item['shootingLocationList'],
    ifContinuousStatistics: item['ifContinuousStatistics'],
    ifContinuousTracking: item['ifContinuousTracking'],
    taskIds: item['taskIds'],
  })
}

export default (
  list, frequencyChartInitFn, eventClickFn,
  zoomCallBack, map
)=>{
  if(!list){
    return;
  }
  const layerGroup = L.featureGroup(),
        infoLayerGroup = L.featureGroup(),
        warningMarkerList = [],
        dataLayerList = []; // 区域图层 关联 数据对象List
  // console.log(list);
  list.forEach(i => {
    const item = itemChange(i);
    let layer;
    // 区域
    if(!item['geom'])return;
    const geoStr = JSON.parse(item['geom']);
    const geojson = L.geoJSON(geoStr, {
      onEachFeature: (feature, e)=>{
        layer = e;
      },
    }).on({
      click: click=>{
        frequencyChartInitFn(item);
      }
    });
    dataLayerList.push({
      data: item,
      layer: geojson,
    })
    layer.on({
      click: (clickEvent) => {
        L.DomEvent.stopPropagation(clickEvent.originalEvent); // 防止事件穿透到 map 触发 map.click 关闭弹窗
        showPreAnnotationDragPopup(map, item, clickEvent.latlng, geojson);
      }
    });
    layer.addTo(layerGroup);

    const center = turf.center(geoStr)['geometry']['coordinates'].reverse();

    const eventList = item['eventList'] || [];
    // 提示 包含事件时增加提示
    const warningMarker = eventList.length > 0 && L.marker(center, {
      icon: L.divIcon({
        html: `<img src="${warningUrl}">`,
        iconSize: iconSizes,
        iconAnchor: iconAnchor,
        className: 'pre-annotation-warning'
      })
    }).on({
      click: click=>{
        const marker = click.target;
        // layerGroup.removeLayer(marker);
        // layerGroup.addLayer(infoLayerGroup);
        frequencyChartInitFn(item);
        // fitBounds
        const bounds = geojson.getBounds();
        if(bounds.isValid()){
          map && map.flyToBounds(bounds, {
            maxZoom: 10,
          });
        }
      }
    }).addTo(layerGroup);
    warningMarker && warningMarkerList.push(warningMarker);
    // 事件
    eventList.forEach(event => {
      L.marker(event, {
        icon: getEventIcon(event.typeName === 'C波段干扰' ? '电磁异常' : event.typeName),
      })
      .on({
        click: click=>{
          eventClickFn(event);
        }
      })
      .bindTooltip(event.eventName, {
        sticky: true,
        className: "leaflet-tooltip-message",
        direction: 'top',
        offset: [0, 0],
      })
      .addTo(infoLayerGroup);
    });
    // 摄像头
    const filmList = item['shootingLocationList'] || [];
    filmList.forEach((film)=>{
      const marker = L.marker(film, {
        icon: L.icon({
          iconUrl: filmIconUrl,
          iconSize: iconSizes,
          iconAnchor: iconAnchor,
        })
      }).addTo(infoLayerGroup);
      getAuthLink(film['videoFileName']).then(res=>{
        if(res.data.code == 1004){
          const popupContent = document.createElement('div'),
                filmApp = filmAppInit(res.data.data);
                filmApp.mount(popupContent);
          marker.bindPopup(popupContent, {
            closeButton: false,
            autoClose: false,
            offset: [ 0, 5 ],
            direction: 'top',
          })
          marker.on({
            remove: ()=>{
              filmApp.unmount();
            }
          })
        }
      }).catch(err=>{
        console.log(err);
      });
    })

  });
  zoomCallBack(layerGroup, warningMarkerList, infoLayerGroup);
  layerGroup.options['dataLayerList'] = dataLayerList;
  return layerGroup;
}